import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";

export async function recordAutoFillLedgerEntry(entry) {
  const doc = {
    transactionId: entry.transactionId,
    programId: entry.programId,
    userId: entry.userId,
    level: entry.level,
    amount: entry.amount,
    transactionType: entry.transactionType,
    fromWallet: entry.fromWallet || null,
    toWallet: entry.toWallet || null,
    matrixPositionId: entry.matrixPositionId || null,
    fillerUserId: entry.fillerUserId || null,
    status: entry.status || "COMPLETED",
    reference: entry.reference || null,
    metadata: entry.metadata || null,
    createdAt: serverTimestamp(),
  };
  await addDoc(collection(db, "autoFillLedger"), doc);
  return doc;
}

export function buildTransactionId(prefix = "TXN") {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
